import CustomBreadcrumb from '@/components/custom-breadcrumb/custom-breadcrumb';
import { Support as SupportForm } from '@/components/support/support';
import { useBreadcrumbs } from '@/hooks/use-breadcrumbs/use-breadcrumbs';

import { Flex } from 'antd';

export function SupportPage() {
  const items = useBreadcrumbs();

  return (
    <Flex vertical>
      <CustomBreadcrumb items={items} />
      <SupportForm />
    </Flex>
  );
}
